import { Tooltip } from 'antd';
import React from 'react';

import type { LinkedVariant } from './types';
import { formatVariantHgvs } from './utils';

type Props = {
  variants: LinkedVariant[];
  count?: number;
  showLinks?: boolean;
  children?: React.ReactNode;
};

const LinkedVariantsTooltip = ({
  variants,
  count,
  showLinks = false,
  children,
}: Props) => {
  const renderVariantText = (variant: LinkedVariant) => {
    const hgvs = formatVariantHgvs(variant);
    if (!showLinks || !variant.variant_id) {
      return hgvs;
    }
    return (
      <a
        href={`/variant-workflow/${variant.variant_id}/clinical_observation`}
        className="probands-samples__variant-link"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          window.open(
            `/variant-workflow/${variant.variant_id}/clinical_observation`,
            '_blank',
          );
        }}
      >
        {hgvs}
      </a>
    );
  };

  return (
    <Tooltip
      color="#fff"
      placement="topLeft"
      overlayClassName="probands-samples__variants-tooltip"
      title={
        <div className="probands-samples__variants-tooltip-content">
          <div className="probands-samples__variants-tooltip-title">
            All variants for sample:
          </div>
          <ul className="probands-samples__variants-tooltip-list">
            {variants.map((variant, index) => (
              <li
                key={index}
                className="probands-samples__variants-tooltip-row"
              >
                <div className="probands-samples__variants-tooltip-cell probands-samples__variants-tooltip-cell--variant">
                  {renderVariantText(variant)}
                </div>
                <div
                  className={`probands-samples__variants-tooltip-cell probands-samples__variants-tooltip-cell--interpretation ${variant.clinical_interpretation || ''}`}
                >
                  {variant.clinical_interpretation}
                </div>
              </li>
            ))}
          </ul>
        </div>
      }
    >
      {children || (
        <span className="probands-samples__variant-count">
          {count ?? variants.length}
        </span>
      )}
    </Tooltip>
  );
};

export default LinkedVariantsTooltip;
